import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

// `subline` lets a page override the pricing claim. Our "$260 flat rate" is
// the DARWIN price for work our own team does. On a service area we do not
// cover ourselves, quoting it implies we set the local inspector's price.
export default function CTABanner({ heading, subline }) {
  return (
    <section className="bg-primary text-white py-8 border-b border-blue-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <h2 className="font-chivo text-2xl md:text-3xl font-bold mb-2">
              {heading || "Ready to Book Your Inspection?"}
            </h2>
            <p className="text-blue-100">
              {subline || "Fast, reliable service • From $260 • 72-hour report delivery"}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              asChild
              size="lg"
              className="bg-secondary hover:bg-secondary/90 text-white font-bold tracking-wide uppercase px-8"
              data-testid="cta-banner-book-button"
            >
              <Link to="/contact">Book Now</Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-2 border-white text-white hover:bg-white hover:text-primary font-bold tracking-wide uppercase px-8"
            >
              <a href="tel:+61413245519">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
